import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { setIsAuthorized, setToken } from 'store/authorization/actions';

export default function useAuth() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const syncAuthState = () => {
      const token = localStorage.getItem('token');

      if (token) {
        dispatch(setToken(token));
        dispatch(setIsAuthorized(true));
      } else {
        dispatch(setToken(null));
        dispatch(setIsAuthorized(false));
      }
    };

    syncAuthState();

    window.addEventListener('storage', syncAuthState);

    return () => {
      window.removeEventListener('storage', syncAuthState);
    };
  }, [dispatch]);
}
